var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart08-template',{attrs:{"board-ids":[242],"data-type":_vm.dataType,"field-code":"public-transportation","graph-id":64,"title":"(공중교통수단) 비상조치계획수립 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }